import React, { Component, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import ContactsIcon from '@material-ui/icons/Contacts'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import GroupIcon from '@material-ui/icons/Group'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import DoneAllIcon from '@material-ui/icons/DoneAll'
// import SettingsIcon from '@material-ui/icons/Settings'
import Badge from '@material-ui/core/Badge'
import { FileTable, Stop, TestTube } from 'mdi-material-ui'
// import Inbox from '@material-ui/icons/Inbox'
import styles from './styles'
import language from 'utils/vast-languagepack'
import CampaignIcon from 'components/theme/CampaignIcon'
// import DudeReadingV2Icon from 'components/theme/DudeReadingV2Icon'
import ConversationIcon from 'components/theme/ConversationIcon'
import { RadioboxMarked /* , AccountMinusOutline */ } from 'mdi-material-ui'
import useScreenRecording from 'use-screen-recording'
import Dialog from '@material-ui/core/Dialog'
import { Button, DialogActions, DialogContent } from '@material-ui/core'
import PublicIcon from '@material-ui/icons/Public'
import { Link as LinkIcon } from '@material-ui/icons'
import { refreshList } from 'actions/view'
import MenuBookIcon from 'components/theme/menuBook'
// import { userSignOut } from 'actions/auth'
import HeaderAvatar from '../HeaderAvatar'
import { openProfileDialog } from 'actions/view'
import { NotificationsItemIcon } from './components/NotificationsItemIcon'
import { isNotificationsEnabled } from 'utils/isNotificationsEnabled'

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
)

const ConversationListItem = connect(
  state => ({
    pathname: state.router.location.pathname,
    last_interaction: state.data?.['inbox/last']?.last_interaction,
    conversationSelected: state.inbox.conversationSelected,
  }),
  null,
)(
  withStyles(styles)(
    class ConversationListItemComponent extends Component {
      state = { unreadCount: 0 }

      componentDidUpdate(prevProps) {
        if (
          prevProps.pathname !== this.props.pathname &&
          this.props.pathname === '/inbox'
        ) {
          this.setState({ unreadCount: 0 })
        }

        if (
          prevProps.conversationSelected !== this.props.conversationSelected
        ) {
          this.setState({ unreadCount: 0 })
        }

        if (
          prevProps.last_interaction !== '' &&
          new Date(prevProps.last_interaction) <
            new Date(this.props.last_interaction)
        ) {
          // beep()
          if (this.props.pathname !== '/inbox' && this.props.pathname !== '/') {
            this.setState({ unreadCount: this.state.unreadCount + 1 })
          }
        }
      }

      render() {
        // if (this.state.unreadCount) beep()
        const icon = this.state.unreadCount ? (
          <Badge
            classes={{
              badge: this.props.classes.badge,
            }}
            badgeContent={this.state.unreadCount}
          >
            <ConversationIcon className={this.props.classes.icon} />
          </Badge>
        ) : (
          <ConversationIcon className={this.props.classes.icon} />
        )
        return (
          <ListItem
            className={
              this.props.open
                ? this.props.classes.listItem
                : this.props.classes.listItemDrawerClosed
            }
            button
            component={Link}
            to="/inbox"
          >
            <ListItemIcon className={this.props.classes.listItemIcon}>
              {icon}
              {!this.props.open && (
                <div className={this.props.classes.iconSubtext}>Chat</div>
              )}
            </ListItemIcon>
            {this.props.open && (
              <ListItemText
                classes={{
                  primary: this.props.classes.listItemText,
                }}
                primary="Chat"
              />
            )}
          </ListItem>
        )
      }
    },
  ),
)

const ConnectedListItem = connect((state, { to, username, vr_account_id }) => {
  return {
    allowed:
      state.data?.screenpermissions?.[
        `screenpermissions-${username}-${vr_account_id}`
      ]?.permissions?.[to?.slice?.(1)],
  }
}, null)(({ children, allowed }) => {
  if (allowed === false) {
    return null
  }

  return <>{children}</>
})

export default connect(null, dispatch =>
  bindActionCreators({ refreshList, openProfileDialog }, dispatch),
)(
  withStyles(styles)(
    ({
      classes,
      open,
      signOut,
      username,
      vr_account_id,
      refreshList,
      openProfileDialog,
      unreadNotificationCount = 0,
    }) => {
      const { isRecording, recording, toggleRecording } = useScreenRecording({
        audio: true,
        video: { cursor: 'always' },
        mimeType: 'video/mp4',
      })
      const [dialogOpen, toggleDialogOpen] = useState(false)

      // const FancyLink = forwardRef(
      //   (props, ref) =>
      //     !!recording && (
      //       <a href={URL.createObjectURL(recording)} ref={ref} {...props}>
      //         {props.children}
      //       </a>
      //     ),
      // )

      // const DownloadLink = (props) =>
      //   !!recording && (
      //     <Link
      //       download
      //       target="_blank"
      //       // to={URL.createObjectURL(recording)}
      //       component={FancyLink}
      //       {...props}
      //     />
      //   )

      const DownloadLink = props =>
        !!recording && (
          <a
            download={`vast_reach_recording_${Date.now()}.mp4`}
            target="_blank"
            rel="noopener noreferrer"
            href={URL.createObjectURL(recording)}
            {...props}
          >
            {props.children}
          </a>
        )

      return (
        <div>
          {isNotificationsEnabled() && (
            <ConnectedListItem
              username={username}
              vr_account_id={vr_account_id}
              to="/notifications"
            >
              <ListItem
                className={
                  open ? classes.listItem : classes.listItemDrawerClosed
                }
                button
                component={Link}
                to="/notifications"
              >
                <ListItemIcon className={classes.listItemIcon}>
                  <NotificationsItemIcon
                    unreadCount={unreadNotificationCount}
                    badgeStyles={classes.badge}
                    iconStyles={classes.icon}
                  />
                  {!open && (
                    <div className={classes.iconSubtext}>Notifications</div>
                  )}
                </ListItemIcon>
                {open && (
                  <ListItemText
                    classes={{ primary: classes.listItemText }}
                    primary="Notifications"
                  />
                )}
              </ListItem>
            </ConnectedListItem>
          )}

          <ConversationListItem open={open} />
          <ConnectedListItem
            to="/contacts"
            username={username}
            vr_account_id={vr_account_id}
          >
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/contacts"
              onClick={() => refreshList('contact')}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <ContactsIcon className={classes.icon} />
                {!open && <div className={classes.iconSubtext}>Contacts</div>}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={language.menuItems.contacts}
                />
              )}
            </ListItem>
          </ConnectedListItem>
          <ConnectedListItem
            to="/campaigns"
            username={username}
            vr_account_id={vr_account_id}
          >
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/campaigns"
              onClick={() => refreshList('campaign')}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <CampaignIcon className={classes.icon} />
                {!open && <div className={classes.iconSubtext}>Campaigns</div>}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Campaigns"
                />
              )}
            </ListItem>
          </ConnectedListItem>
          <ConnectedListItem
            to="/tasks"
            username={username}
            vr_account_id={vr_account_id}
          >
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/tasks"
              onClick={() => refreshList('task')}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <DoneAllIcon className={classes.icon} />
                {!open && <div className={classes.iconSubtext}>Tasks</div>}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={language.menuItems.tasks}
                />
              )}
            </ListItem>
          </ConnectedListItem>
          <ConnectedListItem
            to="/templates"
            username={username}
            vr_account_id={vr_account_id}
          >
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/templates"
              onClick={() => refreshList('template')}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <MailOutlineIcon className={classes.icon} />
                {!open && <div className={classes.iconSubtext}>Templates</div>}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Templates"
                />
              )}
            </ListItem>
          </ConnectedListItem>
          <ConnectedListItem
            to="/forms"
            username={username}
            vr_account_id={vr_account_id}
          >
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/forms"
              onClick={() => refreshList('form')}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <FileTable className={classes.icon} />
                {!open && <div className={classes.iconSubtext}>Forms</div>}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={language.menuItems.forms}
                />
              )}
            </ListItem>
          </ConnectedListItem>
          <ConnectedListItem
            to="/contactgroups"
            username={username}
            vr_account_id={vr_account_id}
          >
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/contactgroups"
              onClick={() => refreshList('group')}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <GroupIcon className={classes.icon} />
                {!open && (
                  <div className={classes.iconSubtext}>
                    Contact
                    <br />
                    Groups
                  </div>
                )}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={language.menuItems.groups}
                />
              )}
            </ListItem>
          </ConnectedListItem>
          <ConnectedListItem
            to="/urls"
            username={username}
            vr_account_id={vr_account_id}
          >
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/urls"
              onClick={() => refreshList('urls')}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <LinkIcon className={classes.icon} />
                {!open && <div className={classes.iconSubtext}>Short URLs</div>}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={'Short URLs'}
                />
              )}
            </ListItem>
          </ConnectedListItem>
          <ConnectedListItem
            username={username}
            vr_account_id={vr_account_id}
            to="/files"
          >
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/files"
              // onClick={() => refreshList('')}
            >
              <ListItemIcon className={classes.listItemIcon}>
                <PublicIcon className={classes.icon} />
                {!open && (
                  <div className={classes.iconSubtext}>
                    Public <br /> Files
                  </div>
                )}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Public Files"
                />
              )}
            </ListItem>
          </ConnectedListItem>
          <ConnectedListItem
            username={username}
            vr_account_id={vr_account_id}
            to="/knowledge"
          >
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/knowledge"
            >
              <ListItemIcon className={classes.listItemIcon}>
                <MenuBookIcon className={classes.icon} />
                {!open && <div className={classes.iconSubtext}>Knowledge</div>}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Knowledge"
                />
              )}
            </ListItem>
          </ConnectedListItem>

          <ListItem
            className={open ? classes.listItem : classes.listItemDrawerClosed}
            button
            onClick={() => openProfileDialog(true)}
          >
            <ListItemIcon className={classes.listItemIcon}>
              <HeaderAvatar open={open} />
              {!open && <div className={classes.iconSubtext}>Profile</div>}
            </ListItemIcon>
            {open && (
              <ListItemText
                classes={{ primary: classes.listItemText }}
                primary="Profile"
              />
            )}
          </ListItem>
          {/* <ListItem
        className={open ? classes.listItem : classes.listItemDrawerClosed}
        button
        component={Link}
        to="/KnowledgeCenter"
      >
        <ListItemIcon className={classes.listItemIcon}>
          <MenuBookIcon className={classes.icon} />
          {!open && (
            <div className={classes.iconSubtext}>
              KNOWLEDGE
              <br /> CENTER
            </div>
          )}
        </ListItemIcon>
        {open && (
          <ListItemText
            classes={{ primary: classes.listItemText }}
            primary={language.menuItems.knowledgeCenter}
          />
        )}
      </ListItem>
      <ListItem
        className={open ? classes.listItem : classes.listItemDrawerClosed}
        button
        component={Link}
        to="/accountsettings"
      >
        <ListItemIcon className={classes.listItemIcon}>
          <SettingsIcon className={classes.icon} />
          {!open && <div className={classes.iconSubtext}>ACCOUNT</div>}
        </ListItemIcon>
        {open && (
          <ListItemText
            classes={{ primary: classes.listItemText }}
            primary={language.menuItems.settingsPrefrences}
          />
        )}
      </ListItem> */}
          {/* <ListItem
				className={classes.listItem}
				button
				onClick={() => signOut()}
				// style={{ position: 'absolute', bottom: 24, left: 0 }}
				// component={Link}
				// to="/accountsettings"
			>
				<ListItemIcon className={classes.listItemIcon}>
					<AccountMinusOutline className={classes.icon} />
					{!open && <div className={classes.iconSubtext}>SIGN OUT</div>}
				</ListItemIcon>
				{open && (
					<ListItemText
						classes={{ primary: classes.listItemText }}
						primary="Sign out"
					/>
				)}
			</ListItem> */}
          {isLocalhost && (
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              component={Link}
              to="/testing"
            >
              <ListItemIcon className={classes.listItemIcon}>
                <TestTube className={classes.icon} />
                {!open && <div className={classes.iconSubtext}>Testing</div>}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary="Testing"
                />
              )}
            </ListItem>
          )}
          {window?.location?.href?.slice?.(0, 29) !==
            'https://console.vastreach.com' && (
            <ListItem
              className={open ? classes.listItem : classes.listItemDrawerClosed}
              button
              onClick={() => {
                toggleDialogOpen(true)
                toggleRecording()
              }}
              // component={Link}
              // to="/accountsettings"
            >
              <ListItemIcon className={classes.listItemIcon}>
                {isRecording ? (
                  <Stop className={classes.icon} />
                ) : (
                  <RadioboxMarked className={classes.icon} />
                )}
                {!open && (
                  <div className={classes.iconSubtext}>
                    {isRecording ? 'Stop' : 'Record'}
                  </div>
                )}
              </ListItemIcon>
              {open && (
                <ListItemText
                  classes={{ primary: classes.listItemText }}
                  primary={isRecording ? 'Stop' : 'Record'}
                />
              )}
            </ListItem>
          )}
          {window?.location?.href?.slice?.(0, 29) !==
            'https://console.vastreach.com' && (
            <Dialog
              maxWidth="xl"
              onClose={() => {
                toggleDialogOpen(false)
                URL.revokeObjectURL(recording)
              }}
              // fullScreen
              open={!!recording && dialogOpen}
            >
              <DialogContent>
                <video
                  style={{ width: '100%' }}
                  autoPlay
                  src={recording && URL.createObjectURL(recording)}
                />
              </DialogContent>
              <DialogActions>
                <Button component={DownloadLink}>Download</Button>
                <Button
                  onClick={() => {
                    toggleDialogOpen(false)
                    URL.revokeObjectURL(recording)
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </div>
      )
    },
  ),
)
